import { Box, Skeleton } from "@mui/material";
import { Typography, Button } from "@mui/material";
// import Loader from "../../Components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import accessImg from "../Assets/access.png";
const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", height: "100vh", width: "100%" }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: 50,
          bgcolor: "primary.main",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 2,
        }}
      >

      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Topbar */}
        <Box
          sx={{
            height: 60,
            px: 3,
            py: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "background.paper",
          }}
        >
          {/* Left Side (Title) */}
          <Box>
            <Skeleton variant="text" width={120} height={30} />
          </Box>

          {/* Right Side (Actions + Profile) */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Skeleton variant="circular" width={30} height={30} />
            <Skeleton variant="circular" width={40} height={40} />
          </Box>
        </Box>

        {/* Table Skeleton */}
        <Box
          sx={{
            flex: 1,
            ml: 2,
            mt: 2,
            backgroundColor: "#ffff",
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          {/* <Loader /> */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              textAlign: "center",
              bgcolor: "background.default",
            }}
          >
            <img
              src={accessImg}
              alt="Access Denied"
              style={{ width: "70px", marginBottom: "20px" }}
            />
            <Typography variant="h4" fontWeight="bold" color="error" gutterBottom>
              Access Denied
            </Typography>
            <Typography variant="h6" gutterBottom>
              You do not have permission to view this page.
            </Typography>
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NoAccess;
